<template>
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="128.000000pt"
    height="128.000000pt"
    viewBox="0 0 128.000000 128.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)"
      fill="#000000"
      stroke="none"
    >
      <path
        d="M195 1258 c-3 -7 -4 -292 -3 -633 l3 -620 445 0 445 0 0 630 0 630
-443 3 c-349 2 -444 0 -447 -10z m855 -623 l0 -595 -165 0 c-91 0 -165 4 -165
8 0 4 4 12 9 17 13 14 271 594 271 609 0 20 -29 40 -117 79 -86 39 -124 45
-140 25 -5 -7 -40 -82 -77 -166 -49 -111 -66 -161 -64 -185 4 -28 5 -29 13
-12 113 256 155 340 172 338 10 -1 53 -18 96 -38 69 -32 78 -39 73 -58 -5 -21
-253 -578 -261 -585 -1 -2 -26 8 -54 22 -59 31 -57 30 -65 10 -4 -11 6 -21 39
-35 25 -11 45 -22 45 -24 0 -3 -97 -5 -215 -5 l-215 0 0 595 0 595 410 0 410
0 0 -595z"
      />
      <path
        d="M274 1126 c-3 -7 -4 -33 -2 -57 l3 -44 365 0 365 0 0 55 0 55 -363 3
c-303 2 -363 0 -368 -12z m696 -46 c0 -20 -7 -20 -330 -20 -323 0 -330 0 -330
20 0 20 7 20 330 20 323 0 330 0 330 -20z"
      />
      <path
        d="M275 969 c-16 -24 18 -29 186 -27 147 3 174 5 174 18 0 13 -28 15
-177 18 -121 2 -179 -1 -183 -9z"
      />
      <path
        d="M275 890 c-13 -21 9 -30 74 -30 45 0 72 5 80 13 6 8 8 17 4 20 -10
11 -151 8 -158 -3z"
      />
      <path
        d="M462 883 c4 -20 27 -27 47 -14 19 12 4 31 -25 31 -19 0 -25 -5 -22
-17z"
      />
      <path
        d="M300 806 c-6 -8 -10 -25 -8 -38 3 -23 3 -23 173 -23 170 0 170 0 173
23 7 47 -9 52 -173 52 -121 0 -155 -3 -165 -14z m305 -26 c4 -6 -45 -10 -140
-10 -95 0 -144 4 -140 10 4 6 62 10 140 10 78 0 136 -4 140 -10z"
      />
      <path
        d="M340 685 c0 -32 2 -35 30 -35 17 0 30 -4 30 -10 0 -5 -13 -10 -30
-10 -28 0 -30 -3 -30 -35 0 -32 2 -35 30 -35 17 0 30 -4 30 -10 0 -5 -13 -10
-30 -10 -28 0 -30 -3 -30 -35 0 -32 2 -35 30 -35 17 0 30 -4 30 -10 0 -5 -13
-10 -30 -10 -28 0 -30 -3 -30 -35 0 -32 2 -35 30 -35 38 0 40 -18 3 -22 -23
-2 -29 -8 -31 -35 -3 -31 -1 -33 28 -33 39 0 36 -24 -3 -28 -26 -3 -27 -6 -27
-60 0 -90 44 -141 123 -142 47 0 88 23 111 60 14 24 16 67 16 314 l0 286 -125
0 -125 0 0 -35z m220 -255 c0 -283 -4 -305 -55 -328 -33 -15 -47 -15 -80 0
-49 22 -79 128 -37 128 39 0 57 55 26 81 -14 11 -14 13 0 21 9 5 16 19 16 32
0 13 -7 29 -16 37 -14 11 -14 13 0 21 21 12 21 52 0 69 -14 11 -14 13 0 21 21
12 21 64 -1 72 -15 6 -15 8 1 19 12 9 17 23 14 42 -2 24 -9 31 -33 36 -17 4
12 7 68 8 l97 1 0 -260z"
      />
      <path
        d="M757 674 c-5 -28 -1 -30 19 -10 18 18 18 22 0 29 -9 4 -16 -3 -19
-19z"
      />
      <path
        d="M801 667 c-16 -16 -14 -34 5 -41 8 -3 12 -2 9 4 -3 6 -1 10 5 10 6 0
8 6 5 13 -4 6 1 3 10 -8 9 -12 11 -21 5 -23 -14 -5 -2 -22 14 -22 8 0 16 9 19
21 4 15 0 23 -14 26 -10 3 -19 9 -19 13 0 14 -27 19 -39 7z"
      />
      <path
        d="M892 605 c-2 -24 -1 -24 17 -7 19 18 18 32 -2 32 -7 0 -14 -11 -15
-25z"
      />
      <path
        d="M741 548 c-5 -13 -30 -67 -55 -122 -25 -54 -46 -104 -46 -110 0 -10
59 -46 74 -46 2 0 15 26 30 59 14 32 42 93 61 135 l34 76 -29 15 c-40 21 -59
19 -69 -7z m59 -38 c-12 -22 -18 -24 -39 -11 -10 7 -11 13 -2 30 10 17 15 19
32 11 15 -9 17 -15 9 -30z m-40 -50 c12 -8 12 -14 -3 -45 -15 -31 -20 -34 -37
-25 -16 9 -18 15 -9 37 18 47 22 50 49 33z m-49 -100 c16 -9 17 -14 8 -33 -16
-30 -15 -30 -38 -18 -18 10 -19 15 -9 36 13 29 13 29 39 15z"
      />
      <path
        d="M677 533 c-13 -13 -7 -53 8 -53 8 0 15 5 15 10 0 6 -4 10 -10 10 -5
0 -10 5 -10 10 0 6 7 10 15 10 8 0 15 5 15 10 0 11 -23 14 -33 3z"
      />
      <path
        d="M643 434 c3 -4 2 -15 -4 -25 -12 -24 -1 -25 17 -1 18 23 17 32 -3 32
-9 0 -13 -3 -10 -6z"
      />
      <path
        d="M607 233 c-12 -12 -7 -60 8 -73 34 -28 84 30 55 65 -13 15 -51 20
-63 8z m49 -24 c9 -15 -11 -33 -30 -26 -9 4 -13 13 -10 22 7 17 30 20 40 4z"
      />
    </g>
  </svg>
</template>

<script>
export default {}
</script>

<style></style>
